import React, { useState } from 'react';
import QuickShareBar from '../components/QuickShareBar';
import FamilyMessage from '../components/FamilyMessage';
const FamilyCheckIn = () => {
  const [messages, setMessages] = useState([{
    sender: 'Sarah',
    content: {
      type: 'emotion' as const,
      value: "I'm thinking of you"
    },
    avatar: 'https://randomuser.me/api/portraits/women/44.jpg',
    time: 'Just now'
  }, {
    sender: 'Tommy',
    content: {
      type: 'photo' as const,
      value: 'https://images.unsplash.com/photo-1682687220795-796d3f6f7000'
    },
    avatar: 'https://randomuser.me/api/portraits/men/22.jpg',
    time: '2 hours ago'
  }, {
    sender: 'Michael',
    content: {
      type: 'voice' as const,
      value: 'voice-message'
    },
    avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
    time: 'Yesterday'
  }]);
  const handleQuickShare = (type: string, value: string) => {
    const newMessage = {
      sender: 'Me',
      content: {
        type: type as 'text' | 'voice' | 'photo' | 'emotion',
        value
      },
      avatar: 'https://randomuser.me/api/portraits/women/65.jpg',
      time: 'Just now'
    };
    setMessages([newMessage, ...messages]);
  };
  return <div className="py-6 space-y-6" data-id="element-354">
      <div data-id="element-355">
        <h1 className="text-2xl font-bold dark:text-white flex items-center gap-3" data-id="element-356">
          <span data-id="element-357">Family</span>
          <span className="text-3xl" data-id="element-358">👨‍👩‍👧‍👦</span>
        </h1>
      </div>
      <div className="card bg-lavender/5 dark:bg-lavender/10" data-id="element-359">
        <div className="flex justify-between items-center" data-id="element-360">
          <h2 className="text-xl font-medium dark:text-white" data-id="element-361">Today's Mood</h2>
          <span className="text-3xl" data-id="element-362">😊</span>
        </div>
      </div>
      <div className="card" data-id="element-363">
        <QuickShareBar onShare={handleQuickShare} data-id="element-364" />
      </div>
      <div className="space-y-3" data-id="element-365">
        {messages.map((message, index) => <FamilyMessage key={index} {...message} onPlay={() => console.log('Playing voice message')} data-id="element-366" />)}
      </div>
    </div>;
};
export default FamilyCheckIn;